
import { Navbar, Row, Col } from 'react-bootstrap';

import '../utils/general.css';
import '../utils/footer.css';


export default function Footer() {
  return (    
    <Navbar expand="lg" bg="dark" data-bs-theme="dark" fixed="bottom" className="justify-content-center mt-5">
      <Row>
        <Col>
          <div>
            <Navbar.Brand>
              <span className='ps-footer'>
                <em>© 2024 Copyright: Pierre Saumet</em>
              </span>
            </Navbar.Brand>
          </div>
          <div>
            <Navbar.Brand>
              <span className='ps-footer'>
                <em>email: psaumet.dvp@gmail.com</em>
              </span>
            </Navbar.Brand>
          </div>
        </Col>
      </Row>
    </Navbar>
  )
}